/**
 * The console page for a resource the assistant names, by its kind and id. Console URLs carry no network or Frontdoor
 * id, so a link opens the resource in the scope selected now, which is the scope the transcript belongs to.
 */

import { AssistantScopeKind } from './api/assistant-scope';

const NETWORK_PAGES: Record<string, string> = {
    IDENTITY: '/identities',
    SERVICE: '/services/advanced',
    SERVICE_POLICY: '/service-policies',
    EDGE_ROUTER: '/routers',
    EDGE_ROUTER_POLICY: '/router-policies',
    SERVICE_EDGE_ROUTER_POLICY: '/service-router-policies',
    CONFIG: '/configs',
    POSTURE_CHECK: '/posture-checks',
    AUTH_POLICY: '/auth-policies',
    CERTIFICATE_AUTHORITY: '/certificate-authorities',
    EXTERNAL_JWT_SIGNER: '/jwt-signers',
    TERMINATOR: '/terminators',
};

const FRONTDOOR_PAGES: Record<string, string> = {
    TCP_SHARE: '/fd/tcp-shares',
    HTTP_SHARE: '/fd/http-shares',
    IPSEC_SHARE: '/fd/ipsec/shares',
    AGENT: '/fd/agents',
    IPSEC_TUNNEL: '/fd/ipsec/tunnels',
    CLIENT_CERTIFICATE: '/fd/tcp-shares/certificates',
    SERVER_CERTIFICATE: '/fd/tcp-shares/server-certificates',
    CERTIFICATE_REQUEST_TOKEN: '/fd/tcp-shares/certificate-request-tokens',
    DOMAIN_NAME: '/fd/http-shares/domain-names',
};

/** The router commands for a resource's page, or null when the console has no page for that kind in this scope. */
export function resourceLink(
    scope: AssistantScopeKind | undefined,
    kind: string | null | undefined,
    id: string | null | undefined
): string[] | null {
    if (!kind || !id) {
        return null;
    }
    const base = (scope === 'frontdoors' ? FRONTDOOR_PAGES : NETWORK_PAGES)[kind];
    return base ? [base, id] : null;
}
